/**
 * @param {string} watermarkText 水印文本
 * @returns {HTMLDivElement} 水印 DOM 元素
 */
function createWatermark(watermarkText) {
  const can = document.createElement('canvas');
  const ctx = can.getContext('2d');
  can.width = 400;
  can.height = 240;
 
  ctx.font = '20px Microsoft YaHei';
  ctx.fillStyle = 'rgba(0, 0, 0, 0.1)';
  ctx.textAlign = 'left';
  ctx.textBaseline = 'middle';
  ctx.rotate(-20 * Math.PI / 180);
 
  // 获取当前日期
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1;
  const day = currentDate.getDate();
  const currentDateString = `${year}-${month}-${day}`;
  ctx.fillText(`${watermarkText}`, can.width / 10, can.height / 2);
 
  const div = document.createElement('div');
  div.style.pointerEvents = 'none';
  div.style.top = '0';
  div.style.left = '0';
  div.style.position = 'absolute';
  div.style.zIndex = '3';
  div.style.width = '100%';
  div.style.height = '100%';
  div.style.background = `url(${can.toDataURL('image/png')}) repeat`;
  return div;
}
 
// 自定义水印指令
export default {
  bind(el, binding) {
    const { watermarkText } = binding.value;
 
    // 确保目标元素有相对定位
    const originalPosition = el.style.position;
    if (!originalPosition || originalPosition === 'static') {
      el.style.position = 'relative';
    }
    
    const watermarkDiv = createWatermark(watermarkText);
    el.__watermark__ = watermarkDiv;
    el.__originalPosition__ = originalPosition;
    el.appendChild(watermarkDiv);
  },
  unbind(el) {
    if (el.__watermark__) {
      el.removeChild(el.__watermark__);
      delete el.__watermark__;
    }
    // 恢复原始定位
    if (el.__originalPosition__) {
      el.style.position = el.__originalPosition__;
      delete el.__originalPosition__;
    }
  }
};